import { PublicKey } from "@solana/web3.js";

// Solana
import { Connection, clusterApiUrl } from "@solana/web3.js";
import { LIQUIDITY_SOURCES } from "helpers/helpers";

export const TOKENLIST_URI = "https://token.jup.ag/strict";

export const stored_user_pubkey = "user_pubkey";
// let connection = new Connection("https://symmetry.genesysgo.net/");
let connection = new Connection("https://mainnet.helius-rpc.com/?api-key=bbfc7418-556e-4a26-b4a2-489d9ffdb4be", "confirmed");


const MARKET_OVERRIDES = [
  {
    base: "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x",
    quote: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    marketAddress: "ArqzdSawkYQQNXUsef2Ndj6fcnNktgyzPuT1ouNZwj4E"
  },
  {
    base: "So11111111111111111111111111111111111111112",
    quote: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    marketAddress: "8BnEgHoWFysVcuFFX7QztDmzuH8r5ZFvyP3sYwn1XTh6"
  },
  {
    base: "LMDAmLNduiDmSiMxgae1gW7ubArfEGdAfTpKohqE5gn",
    quote: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    marketAddress: "Epg66q6wPQbNyyegh8ZiP3iAgway4XFPS99UU3fzMaee"
  }
]

function tryPublicKeyFromStorage(localStorage) {
  let publicKeyStr = localStorage.getItem(stored_user_pubkey);
  return publicKeyStr ? new PublicKey(publicKeyStr) : null;
}

const globalState = {
  authorized: false,
  walletConnected: false,
  prismBalance: 0,
  provider: null,
  wallet: null,
  connection: connection,
  updates: true,
  publicKey: tryPublicKeyFromStorage(localStorage),
  PRISM_OWNER: new PublicKey("3qgS5KYBTFJ6Lt8GujDEQLcgfLPSnFZ5VFMrxoes7rXs"),
  PRISM_FEE: 0.05,
  stats: null,
  assets: [],
  networth: null,
  accounts: [],
  openOrders: [],
  newTx: {},
  closedOpenOrders: {},
  tokenList: null,
  language: "en",
  symmetryStats: null,
  nextUpdate: 0,
  openSearch: 0,
  tradeHistory: null,
  prismMint: "PRSMNsEPqhGVCH1TtWiJqPjJyh2cKrLostPZTNy1o5x",
  markets: [],
  favorites: [],
  queue: [],
  serumMarkets: null,
  marketOverrides: MARKET_OVERRIDES,
  explorer: "https://solscan.io",
  liquiditySources: LIQUIDITY_SOURCES,
  theme: "dark"
};

export default globalState;


